/* istanbul ignore file */
import { Show } from 'framework/show';
import { SensitiveShowElementLayout } from 'framework/sensitiveData';
import AccountViewPage from '.';
import { useAccountId } from '../accountRouting';
import useAccountManagementService from '../useAccountManagementService';

const ViewAccountPage = () => {
  const id = useAccountId();
  const { getById, getOriginalName } = useAccountManagementService();

  return (
    <Show getDataMethod={() => getById(id)}>
      <SensitiveShowElementLayout
        loadSensitiveDataMethod={getOriginalName}
        sensitiveDataId={id}
        sensitiveDataIdSource="accountId"
      >
        <AccountViewPage />
      </SensitiveShowElementLayout>
    </Show>
  );
};

export default ViewAccountPage;
